<template>
  <header class="gp-topbar" v-if="User">
    <div style="display:flex;align-items:center;gap:14px">
      <button class="gp-menu-button" type="button" aria-label="Abrir menu" @click="toggleSidebar">
        <i class="fas fa-bars"></i>
      </button>
      <button class="gp-collapse-button" type="button" aria-label="Recolher ou expandir menu" @click="toggleCollapsed">
        <i class="fas fa-bars"></i>
      </button>
      <div class="gp-topbar-title">
        <small>Área administrativa</small>
        <strong>{{ tituloRota }}</strong>
      </div>
    </div>

    <div class="gp-topbar-actions">
      <button class="gp-support-alert" type="button" :title="textoPendencias" @click="abrirPendencias">
        <i class="fas fa-bell"></i>
        <span v-if="quantidadePendencias > 0" class="gp-support-alert__badge">{{ quantidadePendencias > 99 ? '99+' : quantidadePendencias }}</span>
      </button>
    <div style="position:relative">
      <button class="gp-user" type="button" @click="isDropdownOpenUser = !isDropdownOpenUser">
        <span class="gp-avatar">
          <img v-if="User.urlimage" :src="buildFileUrl(User.urlimage)" alt="Usuário" />
          <span v-else>{{ iniciais }}</span>
        </span>
        <span class="hidden-xs" style="text-align:left">
          <strong style="display:block;font-size:13px">{{ User.nome }}</strong>
          <small style="color:#b9c9e8">{{ User.tusNome || 'Usuário' }}</small>
        </span>
        <i class="fas fa-chevron-down" style="font-size:11px"></i>
      </button>
      <div v-if="isDropdownOpenUser" class="gp-user-menu">
        <div style="padding:8px 12px 12px;border-bottom:1px solid #ebe5dc;margin-bottom:6px">
          <strong>{{ User.nome }}</strong>
          <small style="display:block;color:#68748a">Sessão autenticada</small>
        </div>
        <button type="button" @click="Logout"><i class="fas fa-sign-out-alt" style="margin-right:8px"></i>Sair</button>
      </div>
    </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios'
import authService from '../auth/oidc'

export default {
  name: 'PageTopo',
  data: () => ({ User: null, isDropdownOpenUser: false, quantidadePendencias: 0, usuarioGarantePay: false, timerPendencias: null }),
  computed: {
    tituloRota () { return this.$route?.name || 'GarantePay' },
    iniciais () {
      return String(this.User?.nome || 'GP').split(' ').filter(Boolean).slice(0, 2).map(nome => nome[0]).join('').toUpperCase()
    },
    textoPendencias () {
      if (!this.quantidadePendencias) return 'Nenhum atendimento pendente'
      return this.usuarioGarantePay ? `${this.quantidadePendencias} chamado(s) aguardando atendimento` : `${this.quantidadePendencias} chamado(s) aguardando sua resposta`
    }
  },
  methods: {
    toggleSidebar () { window.dispatchEvent(new Event('layout:toggle-menu')) },
    toggleCollapsed () { window.dispatchEvent(new Event('layout:toggle-collapse')) },
    buildFileUrl (path) {
      if (!path) return ''
      const rel = String(path).replace(/\\/g, '/')
      return `${this.$imgURL}/Telas/CadastroUsuarios/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`
    },
    async carregarPendencias () {
      try {
        const { data } = await axios.get('/Telas/ChamadosAndamento/GetPendencias', { showError: false, showLoading: false })
        this.quantidadePendencias = data.quantidade || 0
        this.usuarioGarantePay = !!data.usuarioGarantePay
      } catch (error) {
        if (error.response?.status !== 401 && error.response?.status !== 403) console.warn('Não foi possível atualizar as pendências de suporte.')
      }
    },
    abrirPendencias () {
      this.$router.push({ path: '/ChamadosAndamento', query: { pendentes: '1', t: Date.now() } })
    },
    async Logout () {
      await authService.signOutRedirect()
    }
  },
  created () {
    const armazenado = localStorage.getItem('_useravgar')
    if (armazenado) {
      try {
        this.User = JSON.parse(armazenado)
      } catch (error) {
        console.error('[GarantePay] Dados de sessão inválidos no topo.', error)
        localStorage.removeItem('_useravgar')
        this.$mensagemErro('Os dados da sessão ficaram inválidos. Entre novamente no sistema.')
        this.$router.push('/')
        return
      }
    }
    this.carregarPendencias()
    this.timerPendencias = window.setInterval(this.carregarPendencias, 60000)
    window.addEventListener('support:refresh', this.carregarPendencias)
  },
  beforeUnmount () {
    if (this.timerPendencias) window.clearInterval(this.timerPendencias)
    window.removeEventListener('support:refresh', this.carregarPendencias)
  }
}
</script>

<style scoped>
.gp-topbar-actions{display:flex;align-items:center;gap:9px}.gp-support-alert{position:relative;width:38px;height:38px;border:1px solid rgba(255,255,255,.16);border-radius:10px;background:rgba(255,255,255,.08);color:#fff;display:grid;place-items:center;font-size:14px;transition:.2s}.gp-support-alert:hover{background:rgba(255,255,255,.16)}.gp-support-alert__badge{position:absolute;top:-6px;right:-7px;min-width:19px;height:19px;padding:0 5px;border-radius:10px;background:#ee7d00;color:#fff;border:2px solid #102a5a;display:grid;place-items:center;font-size:8px;font-weight:800}
</style>
